import {get as _get} from 'lodash';

import ExistingStageEventModel from '@modules/events/forms/ExistingStageEvent/ExistingStageEventModel';
import * as eventsGraphQl from '@graphql/events/events';
import Form from '@appComponents/ReduxFormControls';
import {EVENT_TYPE_STAGE} from '@constants/variables';

export default function ExistingStageEventEditModel() {
    let ExistingStageEventEditModel = ExistingStageEventModel({}, true);

    ExistingStageEventEditModel.query.getEntity = eventsGraphQl.event;
    ExistingStageEventEditModel.fields.property_licence.props.disabled = true;
    ExistingStageEventEditModel.fields.event_preset.props.disabled = false;
    ExistingStageEventEditModel.fields.status.props.hidden = true;
    ExistingStageEventEditModel.fields.end_datetime.props.required = true;
    ExistingStageEventEditModel.editForm = true;
    ExistingStageEventEditModel.fields.id = {
        dataMapKey: 'event.st_event.id',
        props: {
            component: Form.SemanticInput,
            hidden: true,
            name: 'id',
        },
    };
    ExistingStageEventEditModel.fields.event_stage_type = {
        props: {
            component: Form.SemanticInput,
            name: 'eventStageType',
            hidden: true,
            defaultValue: EVENT_TYPE_STAGE,
        },
    };
    ExistingStageEventEditModel.mutation.deleteEntity = eventsGraphQl.srEventDeleteMutation;
    ExistingStageEventEditModel.title
        = (data) => `Edit Stage event ${_get(data, 'event.id', '')} (stage ID ${_get(data, 'event.st_event.stage.id', '')})`;

    return ExistingStageEventEditModel;
}
